import type { dealerSearchIncoming } from "@dealer-center/ddc-pages-account-search-interface";
import type { useSearchFilterHookStates } from ".";

export const handleAccountTypes = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.accountTypes !==
    currentStates.accountTypesValue.map(({ value }) => value)
  ) {
    currentStates.setAccountTypesValue(
      filters.accountTypes
        ? filters.accountTypes.map(accountType => ({
            value: accountType,
            label: accountType
          }))
        : []
    );
  }
};

export const handleCountries = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.countries !== currentStates.countryValue.map(({ value }) => value)
  ) {
    currentStates.setSelectedCountryValue(
      filters.countries
        ? filters.countries.map(country => ({
            value: country,
            label: country
          }))
        : []
    );
  }
};

export const handleUrls = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (filters.urls !== currentStates.urlValue.map(({ value }) => value)) {
    currentStates.setSelectedUrlValue(
      filters.urls ? filters.urls.map(url => ({ value: url, label: url })) : []
    );
  }
};

export const handleControlCenterPlatforms = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.controlCenterPlatforms !==
    currentStates.controlCenterPlatformsValue.map(({ value }) => value)
  ) {
    currentStates.setControlCenterPlatformsValue(
      filters.controlCenterPlatforms
        ? filters.controlCenterPlatforms.map(platform => ({
            value: platform,
            label: platform
          }))
        : []
    );
  }
};

export const handleIds = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (filters.ids !== currentStates.idValue.map(({ value }) => value)) {
    currentStates.setIdValue(
      filters.ids ? filters.ids.map(id => ({ value: id, label: id })) : []
    );
  }
};

export const handleResources = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.resources?.matchAll !==
    currentStates.resourcesMatchAllValue.map(({ value }) => value)
  ) {
    currentStates.setResourcesMatchAllValue(
      filters.resources?.matchAll
        ? filters.resources.matchAll.map(resource => ({
            value: resource.toString(),
            label: resource.toString()
          }))
        : []
    );
  }
  if (
    filters.resources?.matchAny !==
    currentStates.resourcesMatchAnyValue.map(({ value }) => value)
  ) {
    currentStates.setResourcesMatchAnyValue(
      filters.resources?.matchAny
        ? filters.resources.matchAny.map(resource => ({
            value: resource.toString(),
            label: resource.toString()
          }))
        : []
    );
  }
  if (
    filters.resources?.matchNone !==
    currentStates.resourcesMatchNoneValue.map(({ value }) => value)
  ) {
    currentStates.setResourcesMatchNoneValue(
      filters.resources?.matchNone
        ? filters.resources.matchNone.map(resource => ({
            value: resource.toString(),
            label: resource.toString()
          }))
        : []
    );
  }
};

export const handleDealerCodes = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.dealerCodes?.matchAll !==
    currentStates.dealerCodesMatchAll?.map(({ value }) => {
      return {
        codes: ["*"],
        type: value
      };
    })
  ) {
    currentStates.setDealerCodesMatchAll(
      filters.dealerCodes?.matchAll
        ? filters.dealerCodes.matchAll.map(dealerCode => ({
            value: dealerCode.type,
            label: dealerCode.type
          }))
        : []
    );
  }
};

export const handleFranchises = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.franchises?.matchAll !==
    currentStates.franchisesMatchAllValue.map(({ value }) => value)
  ) {
    currentStates.setFranchisesMatchAllValue(
      filters.franchises?.matchAll
        ? filters.franchises.matchAll.map(franchise => ({
            value: franchise,
            label: franchise
          }))
        : []
    );
  }
  if (
    filters.franchises?.matchAny !==
    currentStates.franchisesMatchAnyValue.map(({ value }) => value)
  ) {
    currentStates.setFranchisesMatchAnyValue(
      filters.franchises?.matchAny
        ? filters.franchises.matchAny.map(franchise => ({
            value: franchise,
            label: franchise
          }))
        : []
    );
  }
  if (
    filters.franchises?.matchNone !==
    currentStates.franchisesMatchNoneValue.map(({ value }) => value)
  ) {
    currentStates.setFranchisesMatchNoneValue(
      filters.franchises?.matchNone
        ? filters.franchises.matchNone.map(franchise => ({
            value: franchise,
            label: franchise
          }))
        : []
    );
  }
};

export const handleStates = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (filters.states !== currentStates.stateValue.map(({ value }) => value)) {
    currentStates.setSelectedStateValue(
      filters.states
        ? filters.states.map(state => ({ value: state, label: state }))
        : []
    );
  }
};

export const handleCreated = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.created?.before !== currentStates.dateBeforeValue?.toISOString()
  ) {
    currentStates.setDateBeforeValue(
      filters.created?.before ? new Date(filters.created?.before) : undefined
    );
  }
  if (filters.created?.after !== currentStates.dateAfterValue?.toISOString()) {
    currentStates.setDateAfterValue(
      filters.created?.after ? new Date(filters.created?.after) : undefined
    );
  }
};

export const handleStatuses = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.statuses !== currentStates.statusValue.map(({ value }) => value)
  ) {
    currentStates.setStatusValue(
      filters.statuses
        ? filters.statuses.map(status => ({ value: status, label: status }))
        : []
    );
  }
};

export const handlePostalCodes = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.postalCodes !==
    currentStates.postalCodeValue.map(({ value }) => value)
  ) {
    currentStates.setPostalCodeValue(
      filters.postalCodes
        ? filters.postalCodes.map(postalCode => ({
            value: postalCode,
            label: postalCode
          }))
        : []
    );
  }
};

export const handleVerticalTypes = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (
    filters.verticalTypes !==
    currentStates.verticalTypesValue.map(({ value }) => value)
  ) {
    currentStates.setVerticalTypesValue(
      filters.verticalTypes
        ? filters.verticalTypes.map(verticalType => ({
            value: verticalType,
            label: verticalType
          }))
        : []
    );
  }
};

export const handleNames = (
  filters: dealerSearchIncoming,
  currentStates: useSearchFilterHookStates
) => {
  if (filters.names !== currentStates.nameValue.map(({ value }) => value)) {
    currentStates.setNameValue(
      filters.names
        ? filters.names.map(name => ({ value: name, label: name }))
        : []
    );
  }
};

export default [
  handleAccountTypes,
  handleCountries,
  handleUrls,
  handleControlCenterPlatforms,
  handleIds,
  handleNames,
  handleVerticalTypes,
  handlePostalCodes,
  handleStatuses,
  handleCreated,
  handleStates,
  handleFranchises,
  handleDealerCodes,
  handleResources
];
